import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { setConfig } from "@core/services/api/config";
import { initFirebase } from "@core/services/api/firebase";
import { TrackingProvider } from "@core/features/tracking";
import { rememberAttribution, rememberLanding } from "@platform/features/marketing";
import { PlatformApp } from "./PlatformApp";
import "@themes/pollinator/styles/index.css";

// Setup API config with env variables (env variables are not read in @themes)
setConfig({
  apiUrl: import.meta.env.VITE_API_URL,
  firebaseEnv: import.meta.env.VITE_FIREBASE_ENV,
  chimeApiUrl: import.meta.env.VITE_CHIME_API_URL,
  env: import.meta.env.MODE,
});

// Initialize Firebase
initFirebase();

// Remember the campaign that brought this visit, while the parameters are
// still on the address. By the time anyone reaches a form they have usually
// navigated and the URL no longer says where they came from.
rememberAttribution();
// And the anchor it arrived at, which is how a link straight to a form set
// into a longer page is told from somebody scrolling down to it.
rememberLanding();

// Create a query client
const queryClient = new QueryClient();

// Create root element and render the app
// Note: Platform state is now managed by Zustand (usePlatformStore)
// Invitation state is also managed by Zustand (InvitationSlice)
// Dialog state is also managed by Zustand (DialogSlice)
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TrackingProvider
          debug={{ enabled: false }}
          services={{ posthog: true, google_analytics: true }}
        >
          <PlatformApp />
        </TrackingProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);
